<template>
  <section class="preview-section">
    <div class="galaxy bg-image galaxy-rotation" />
    <div class="title-wrap font-rubik">
      <h1 class="preview-title test-22">
        {{ getContent('preview.title') }}
      </h1>
      <div class="preview-subtitle section-title">
        <span>
          {{ getContent('preview.subtitle') }}
        </span>
      </div>
    </div>
    <div class="preview-content-wrap">
      <div class="content-images-wrap">
        <NuxtImg
          preload
          width="500"
          height="500"
          sizes="200px md:500px"
          class="content-image-1 preview-hero-levitation"
          src="/preview_section_hero_1.webp"
          :alt="getContent('preview.hero_image_alt_1')"
        />
        <NuxtImg
          preload
          width="500"
          height="500"
          sizes="200px md:500px"
          class="content-image-2 preview-hero-levitation"
          src="/preview_section_hero_2.webp"
          :alt="getContent('preview.hero_image_alt_2')"
        />
        <NuxtImg
          preload
          width="650"
          height="650"
          sizes="259px md:650px"
          class="content-image-3 preview-hero-levitation"
          src="/preview_section_hero_3.webp"
          :alt="getContent('preview.hero_image_alt_3')"
        />
        <NuxtImg
          preload
          width="500"
          height="500"
          sizes="200px md:500px"
          class="content-image-4 preview-hero-levitation"
          src="/preview_section_hero_4.webp"
          :alt="getContent('preview.hero_image_alt_4')"
        />
        <NuxtImg
          preload
          width="500"
          height="500"
          sizes="200px md:500px"
          class="content-image-5 preview-hero-levitation"
          src="/preview_section_hero_5.webp"
          :alt="getContent('preview.hero_image_alt_5')"
        />
      </div>
      <div class="content-mask bg-image" />
      <div
        v-if="breakpoints.mdAndUp"
        class="content-gradient"
      />
      <ClientOnly>
        <PreviewSectionContent />
      </ClientOnly>
    </div>
  </section>
</template>

<script setup>
const breakpoints = useBreakpoints()
</script>

<style lang="scss" scoped>
.preview-section {
  height: 100dvh;
  min-height: 1100px;
  position: relative;
  text-align: center;

  .title-wrap {
    margin-top: 154px;
    position: relative;
    display: inline-block;

    .preview-title {
      color: white;
      font-size: 96px;
      line-height: 114px;
    }

    .preview-subtitle {
      display: block;
      text-align: end;
    }
  }

  .preview-content-wrap {
    left: 0;
    bottom: 0;
    width: 100vw;
    position: absolute;

    .content-images-wrap {
      left: 50%;
      z-index: 1;
      bottom: 160px;
      height: 650px;
      width: 1280px;
      position: absolute;
      transform: translateX(-50%);

      .content-image-1 {
        left: 0;
        top: 23.1%;
        z-index: 1;
        width: 500px;
        height: 500px;
        object-fit: cover;
        position: absolute;
      }

      .content-image-2 {
        left: 20%;
        top: 23.1%;
        z-index: 2;
        width: 500px;
        height: 500px;
        object-fit: cover;
        position: absolute;
        animation-delay: -2s;
      }

      .content-image-3 {
        top: 0;
        z-index: 3;
        left: 30.5%;
        width: 650px;
        height: 650px;
        object-fit: cover;
        position: absolute;
      }

      .content-image-4 {
        top: 23.1%;
        z-index: 2;
        right: 10.5%;
        width: 500px;
        height: 500px;
        object-fit: cover;
        position: absolute;
        animation-delay: -2s;
      }

      .content-image-5 {
        right: 0%;
        top: 23.1%;
        z-index: 1;
        width: 500px;
        height: 500px;
        object-fit: cover;
        position: absolute;
      }
    }

    .content-mask {
      left: 0;
      bottom: 0;
      z-index: 2;
      width: 100vw;
      height: 432px;
      position: absolute;
      background-image: url('/preview_section_mask.webp');
    }

    .content-gradient {
      left: 0;
      bottom: 0;
      z-index: 0;
      width: 100vw;
      height: 703px;
      position: absolute;
      background: linear-gradient(180deg, #00000000 0%, #FFC30052 100%);
    }
  }
}

@media only screen and (max-width: $sm) {
  .preview-section {
    height: auto;
    min-height: auto;
    padding-bottom: 0px;

    .title-wrap {
      margin-top: 138px;

      .preview-title {
        font-size: 39px;
        line-height: 46px;
      }

      .preview-subtitle {
        font-size: 24px;
        line-height: 28px;
      }
    }

    .preview-content-wrap {
      display: flex;
      margin-top: 10px;
      position: relative;
      align-items: center;
      flex-direction: column;

      .content-images-wrap {
        left: 0;
        bottom: 0;
        width: 506px;
        height: 259px;
        position: relative;
        transform: translateX(0);

        .content-image-1,
        .content-image-2,
        .content-image-4,
        .content-image-5 {
          width: 200px;
          height: 200px;
        }

        .content-image-3 {
          width: 259px;
          height: 259px;
        }
      }

      .content-mask {
        top: 168px;
        bottom: auto;
        height: 178px;
        background-image: none;
        background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 52%, rgba(0, 0, 0, 0) 100%);
      }
    }
  }
}
</style>
